import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.58.2_babel-plugin-macros@3.1.0_react_6e7d97cea24a18f860d7fe2598e63979/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.58.2_babel-plugin-macros@3.1.0_react_6e7d97cea24a18f860d7fe2598e63979/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.58.2_babel-plugin-macros@3.1.0_react_6e7d97cea24a18f860d7fe2598e63979/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/vercel/path0/src/blocks/AboutSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/vercel/path0/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/EnhancedCTA/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQBlockComponent"] */ "/vercel/path0/src/blocks/FAQBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/vercel/path0/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/HeroSlider/Component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/MapBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedGallery"] */ "/vercel/path0/src/blocks/ProjectGallery/AnimatedGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedGrid"] */ "/vercel/path0/src/blocks/ServicesGrid/AnimatedGrid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/Stats/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/vercel/path0/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/vercel/path0/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/vercel/path0/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["buttonVariants"] */ "/vercel/path0/src/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighImpactHero"] */ "/vercel/path0/src/heros/HighImpact/index.tsx");
